export default [
	{ text: 'MR', value: 'MR' },
	{ text: 'MRS', value: 'MRS' },
	{ text: 'MISS', value: 'MISS' },
	{ text: 'MS', value: 'MS' },
	{ text: 'BABY', value: 'BABY' },
	{ text: 'DR', value: 'DR' },
	{ text: 'FR', value: 'FR' },
	{ text: 'LADY', value: 'LADY' },
	{ text: 'LORD', value: 'LORD' },
	{ text: 'MSTR', value: 'MSTR' },
	{ text: 'PROF', value: 'PROF' },
	{ text: 'REV', value: 'REV' },
	{ text: 'SIR', value: 'SIR' },
	{ text: 'SR', value: 'SR' }
];



// WEBPACK FOOTER //
// ./src/data/titles.js